// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Qpx7","tabsBox":"styles_tabsBox__1_yib","createButton":"styles_createButton__2Jx7d"};